import React from "react";
import { toast as alert } from "react-toastify";
import AFSService from "../../../../../services/AFSService";
import WComponent from "../../../../common/WComponent";

class CheckAgainButton extends WComponent {
	state = { checking: false };

	askForAnotherCheck = async () => {
		let { documentId, onChecked } = this.props;

		this.update({ checking: true });
		try {
			let result = await AFSService.verifyDocumentAgain({ documentId });
			if (result.started) alert.success("Checking the document again — this takes a moment.");
			else alert.info(result.reason);
			if (onChecked) onChecked();
		} catch (error) {
			alert.error("The document could not be checked again.");
		}
		this.update({ checking: false });
	};

	render() {
		let { className } = this.props;
		let { checking } = this.state;

		return (
			<button
				type="button"
				className={"tk-button tk-button--secondary tk-button--compact " + (className || "")}
				disabled={checking}
				onClick={this.askForAnotherCheck}
			>
				{checking ? "Checking…" : "Check again"}
			</button>
		);
	}
}

export default CheckAgainButton;
